// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function getTags(lotTags, parcelName) {
  var tags = Belt_Array.map(lotTags, (function (tagString) {
          if (tagString === "NoReserve") {
            return /* NoReserve */0;
          }
          
        }));
  if (parcelName !== undefined) {
    return Belt_Array.concat(tags, [/* Parcel */{
                  _0: parcelName
                }]);
  } else {
    return tags;
  }
}

function lotCreators(creatorPrefix, creators) {
  var creatorsName = creators.join(" | ");
  if (creatorPrefix !== undefined) {
    return "" + creatorPrefix + " " + creatorsName + "";
  } else {
    return creatorsName;
  }
}

export {
  getTags ,
  lotCreators ,
}
/* No side effect */
